import { Typography, Container } from "@mui/material";
import { Link } from '@mui/material';           // MUI Link

// Define a reusable style object for paragraph spacing for consistency
const paragraphStyle = { mb: 2 };

function Privacy() {
    return(
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant='h4' component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Privacy Policy
            </Typography>
            <Typography variant='subtitle1' color="text.secondary" gutterBottom>
                mobidawg, llc
            </Typography>
            <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 4 }}>
                Last updated: July 20, 2025
            </Typography>

            <Typography variant="body1" sx={paragraphStyle}>
                At mobidawg.com, the privacy of our guests is important to us. Our privacy policy has been developed to keep your trust so you can find benefit visiting our site, return often, and invite your friends. This privacy policy document highlights the types of personal information that is received and collected by mobidawg.com and how it is used.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                This policy does not address our practices regarding information that may be collected through our products or applications. Individual products or applications may have additional guidelines and will be made available during licensing or subscription. As business environments and technology often change, we will regularly review and revise our privacy policy.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                This policy includes any and all domains managed and served by mobidawg.com, including mobidawg.mobi when it becomes available.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                This version of mobidawg.com is hosted on <Link href="https://firebase.google.com/docs/hosting/" target="_blank" rel="noopener noreferrer">Firebase Hosting</Link> at <Link href="https://mobidawg.web.app/" target="_blank" rel="noopener noreferrer" title='Like a dog with thumbs.'>https://mobidawg.web.app</Link>. As other sites and servers under the mobidawg, llc banner become available, the same policy will apply.
            </Typography>

            <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2, fontWeight: 'bolder' }}>
                Cookies and Other Technologies
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                For detailed information on our use of cookies, please see our <Link href="/legal/cookies">Cookies Policy</Link>.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                mobidawg, llc indirectly uses cookies as a consequence of using third-party services (like Google Analytics and potentially Google Adsense) to store information about guest preferences, record user-specific information on which pages the user accesses or visits, and customize Web page content based on a guest's browser type or other information that the visitor sends via their browser.
            </Typography>
            <Typography variant="body2" sx={{ ...paragraphStyle, mt: 4 }}>
                To read the full, official policy document, please <Link href="/src/assets/docs/mobidawg_Privacy_Policy.pdf" target="_blank" rel="noopener noreferrer">click here (PDF)</Link>.
            </Typography>
        </Container>
    )
}

export default Privacy;
